<template>
  <header class="app-header">
    <div class="container">
      <q-toolbar>
        <a href="/" class="app-header__logo"><i-app-jstaking-logo /></a>
        <q-space />
        <div class="app-header__actions">
          <div class="app-header__buttons">
            <app-settings />
            <connect-wallet />
          </div>
        </div>
      </q-toolbar>
    </div>
  </header>
</template>
